export default (params) => ({
  trigger: {
    name: 'coolblues_choice.read_explanation',
    params: params,
  },
  config: {
    schema: {
      subject_id: {
        type: 'string',
      },
    },
    event: {
      name: 'read_explanation',
      params: {
        sub_feature: null,
        subject_type: 'label',
      },
    },
  },
});
